import repository from './repsitory'

const resource = '/productSubCategory'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    getByCategory (categoryId) {
        return repository.get(`${resource}/category/${categoryId}`)
    },
    addproductSubCategory (data) {
        return repository.post(`${resource}`, data)
    },
    updateproductSubCategory (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    remove (id) {
      return repository.delete(`${resource}/${id}`)
  },
}
